export default function Error500() {
  return (
    <>
      <p>Oups, une erreur inattendue s'est produite. Nous ne pouvons procéder à votre requête actuellement.</p>
      <p>Si le problème persiste, contactez-nous avec plus de détails sur le problème (par exemple comment reproduire l'erreur).</p>
      <p>Merci de votre collaboration!</p>
    </>
  )
}
